import { ReactComponent as Arrow } from '../../assets/home/trvto_arrow.svg';
import { useNavigate } from 'react-router-dom';

const HomeCarouselCard = ({ data, type }) => {
    const navigate = useNavigate();

    const limit = 9;

    const handleNavigate = () => {
        const title = data?.title?.trim();

        if (!title) {
            return;
        }

        if (type) {
            navigate(`/search-result/trip/${title}`, {
                state: { limit }
            });
        } else {
            navigate(`/search-result/trip?type=${encodeURIComponent(title)}`, {
                state: {
                    limit
                }
            });
        }
    };

    return (
        <div className='carouselClickableItem carousel-item' onClick={handleNavigate}>
            <img src={data.image} alt={data.title} loading='lazy' decoding='async' />

            <div className='carouselInnerCard'>
                <div className='innerBorder' />

                <div className='alignCenter'>
                    <p>{data.title}</p>

                    <button
                        type='button'
                        className='carouselCardInnerBtn'
                        onClick={(e) => {
                            e.stopPropagation();
                            handleNavigate();
                        }}
                    >
                        <Arrow />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default HomeCarouselCard;
